import { findIndex, clone } from 'lodash-es';
import draggable from 'vuedraggable';
import ConduitEventsService from '../services/conduitEventsService';

export default {
  components: {
    draggable,
  },

  data() {
    return {
      searchTerms: [],
      searchResults: [],
      selected: [],
    };
  },

  created() {
    document.addEventListener('clearTabSelection', this.clearSelection);
  },

  beforeUnmount() {
    document.removeEventListener('clearTabSelection', this.clearSelection);
  },

  computed: {
    playing() {
      return this.production.playing;
    },

    production() {
      return this.$store.state.production.production;
    },

    allSelected() {
      return this.selected.length && this.selected.length === this.searchResults.length;
    },
  },

  methods: {
    clearSelection() {
      this.selected = [];
    },

    addTag(tag) {
      if (this.searchTerms.indexOf(tag) === -1) {
        this.searchTerms.push(tag);
        this.doSearch();
      }
    },

    removeTag(tag) {
      const index = findIndex(this.searchTerms, (o) => o === tag);
      this.searchTerms.splice(index, 1);
      this.doSearch();
    },

    toggleAll($event) {
      if (!$event.target.checked) {
        this.selected = [];
      } else {
        this.selected = clone(this.searchResults);
      }
    },

    async addSelectedToPlaylist(type) {
      const items = this.selected.map((item) => this.clone(item));

      await this.$store.dispatch('addLayouts', { items });

      if (type === 'Panels') {
        await this.$store.dispatch('getTimelinePanels');
      } else if (type === 'Graphics') {
        await this.$store.dispatch('getTimelineTemplates');
      } else if (type === 'assets') {
        await this.$store.dispatch('assets/getTimelineAssets');
      } else if (type === 'polls') {
        await this.$store.dispatch('polls/getTimelinePolls');
      } else {
        await this.$store.dispatch('getTimelineThemes');
      }

      await this.$store.dispatch('generateShortUrls');
      this.$store.dispatch('updateTimeline');

      this.selected = [];

      ConduitEventsService.track(
        'producer.added.items-to-playlist',
        {
          type,
          count: items?.length || 1,
          production_id: this.production._id,
          component: 'tab-mixins.js',
          method: 'addSelectedToPlaylist',
          items,
        },
        {
          ownerId: this.production.owner,
          userId: this.$store.state.user.id,
          isStaff: this.$store.getters.isStaff,
        },
      );
    },

    async addSelectedToGroup(type, parentTimelineId) {
      const items = this.selected.map((item) => this.clone(item));

      await this.$store.dispatch('addLayouts', {
        parentId: parentTimelineId,
        items,
      });

      this.selected = [];

      await this.$store.dispatch('getTimelineTemplates');          
      await this.$store.dispatch('generateShortUrls', items.map((item) => item.timeline_id));
      this.$store.dispatch('updateTimeline');

      ConduitEventsService.track(
        'producer.added.items-to-playlist',
        {
          type,
          count: items?.length || 1,
          production_id: this.production._id,
          component: 'tab-mixins.js',
          method: 'addSelectedToGroup',
          items,
        },
        {
          ownerId: this.production.owner,
          userId: this.$store.state.user.id,
          isStaff: this.$store.getters.isStaff,
        },
      );
    },

    async addToPlaylist(item, type) {
      // Ignore addToPlaylist while disconnected from socket server.
      if (!this.$store.state.clients.isSocketConnected) {
        console.warn('Ignoring addToPlaylist while disconnected from socket server');
        return;
      }

      const items = [this.clone(item)];
      await this.$store.dispatch('addLayouts', { items });

      switch (type) {
        case 'Panel': {
          await this.$store.dispatch('getTimelinePanels');
          break;
        }

        case 'asset': {
          await this.$store.dispatch('assets/getTimelineAssets');
          break;
        }

        case 'poll': {
          await this.$store.dispatch('polls/getTimelinePolls');
          break;
        }

        case 'Graphic': {
          await this.$store.dispatch('getTimelineTemplates');
          break;
        }

        default: { // Themes
          await this.$store.dispatch('getTimelineThemes');
          break;
        }
      }

      await this.$store.dispatch('generateShortUrls');
      this.$store.dispatch('updateTimeline');
      this.$store.dispatch('trackSportradarInGameElement');

      ConduitEventsService.track(
        'producer.added.items-to-playlist',
        {
          type,
          count: items?.length || 1,
          production_id: this.production._id,
          component: 'tab-mixins.js',
          method: 'addToPlaylist',
          items,
        },
        {
          ownerId: this.production.owner,
          userId: this.$store.state.user.id,
          isStaff: this.$store.getters.isStaff,
        },
      );
    },
  },
};
